module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/cocktail.svg?7c025b55342bb252f46d7ff7ae2869ca";